export default __webpack_public_path__ + "./images/masterCard.5d1b6845.svg";